import { getInterpolatedEvalString } from '../getInterpolatedEvalString.js';

/* eslint-disable no-eval */
export const execEvaluateExpression = async ({ executionMode, expression, expressionString, args, meta, globalVariables, evalMode }) => {
  if (evalMode === true && executionMode !== 'vm') {
    return { success: true, data: getInterpolatedEvalString({ code: expressionString, input: { input: args[0], ...globalVariables } }), message: 'Expression evaluated successfully.' };
  }

  if (executionMode === 'browser') {
    globalThis.evalCount++;
    return { success: true, data: eval(expressionString)(...args), message: 'Expression evaluated successfully.' };
  }

  if (executionMode === 'plain') {
    globalThis.evalCount++;
    return { success: true, data: eval(expressionString)(...args), message: 'Expression evaluated successfully.' };
  }

  if (executionMode === 'vm') {
    globalThis.isolatedVmCount++;
    // Keep the VM-only server helper out of browser bundles; Vite follows even runtime-guarded literal dynamic imports.
    const codeRunnerModule = '../../server/evalExpressionInCodeRunner.js';
    const { evalExpressionInCodeRunner } = await import(/* @vite-ignore */ codeRunnerModule);
    return await evalExpressionInCodeRunner({ code: expressionString, args, expression, meta: { expressionString, ...meta } });
  }

  console.error(`CRITICAL ERROR - Attempt to run an unsafe eval was stopped. useVM must be true for server-side code runner evaluation or false for explicitly trusted plain evaluation.`);
  return { success: false, message: 'Cannot run unsafe evals' };
};
